module.exports = __webpack_public_path__ + "static/media/suitcase.6ee3a44c.svg";